import { createSelector } from 'reselect';
import { AppState } from '../../../store';

export const ThankyouSelector = (state: AppState) => state.thankyou;
export const thankyouInfoSelector = createSelector(ThankyouSelector, item => {
        return item.data
});
export const getBookingStatusSelector = createSelector(ThankyouSelector, item => {
        return item.status
});
export const getPaymentStatusSelector = createSelector(ThankyouSelector, item => {
        return item.payment
});
export const getThankyouPageError = createSelector(ThankyouSelector, item => {
        return item.isError
});
export const getFeedBackStatusSelector = createSelector(ThankyouSelector, item => {
        return item.feedbackTaken
});
